import type { WelcomeStep } from "../types/WelcomeFlowTypes";

// The tour's centered intro; anchored steps load live from the Library flow guide.
export const libraryExistingUserSteps: WelcomeStep[] = [{ key: "library-whats-new", label: "What's new", centered: true }];
